import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Table,
  Tbody,
  Tr,
  Td,
  Flex,
  Text,
  useToast,
  Spinner,
} from "@chakra-ui/react";
import { ChevronLeft } from "lucide-react";
import { useLocation } from "react-router-dom";
import { getShadeDetailById } from "../../../redux/api/admin/shadeApi";
import { formatDateTime, getFullName } from "../../../../utils/commonFunctions";

function ShadeDetail(props) {
  const location = useLocation();
  const [itemImages, setItemImages] = useState([]);
  const shadeId = props.shadeId;
  const [loading, setLoading] = useState(false);

  console.log("shadeId", shadeId);
  const toast = useToast();
  const [shadeDataDetail, setShadeDataDetail] = useState({
    shadeNumber: "",
    category: "",
    maxWidth: "",
    fabric: "",
    gsm: "",
    uvBlockage: "",
    opennessFactor: "",
    greenGuard: "",
    description: "",
    isPrintingRequired: false,
    items: [],
    shadeMedia: [],
    shadeName: "",
    createdTime: "",
    modifiedTime: "",
    creatorId: "",
    modifierId: "",
    createdBy: { firstName: "", lastName: "" },
    modifiedBy: { firstName: "", lastName: "" }
  });

  useEffect(() => {
    if (shadeId) {
      setLoading(true);
      getShadeDetailById(shadeId)
        .then((response) => {
          console.log("Shade API Response:", response);

          if (response.data && response.data.data && response.data.data.shade) {
            const shadeData = response.data.data.shade;
            console.log("Raw shadeData:", shadeData);

            // Parse the stringified arrays
            let parsedMedia = [];
            let parsedItems = [];

            try {
              // Parse shadeMedia - it's a stringified array of URLs
              if (shadeData.shadeMedia) {
                if (typeof shadeData.shadeMedia === 'string') {
                  try {
                    // Directly parse the JSON string to get array of URLs
                    const mediaUrls = JSON.parse(shadeData.shadeMedia);
                    console.log("Parsed media URLs:", mediaUrls);

                    // Convert each URL to an object with url property
                    parsedMedia = mediaUrls.map(url => ({
                      url: url,
                      result: true
                    }));
                  } catch (e) {
                    console.error("Error parsing shadeMedia JSON:", e);
                    // Fallback: if it's a simple string with URLs
                    if (shadeData.shadeMedia.includes('http')) {
                      parsedMedia = [{
                        url: shadeData.shadeMedia,
                        result: true
                      }];
                    }
                  }
                } else if (Array.isArray(shadeData.shadeMedia)) {
                  // If it's already an array
                  parsedMedia = shadeData.shadeMedia.map(url =>
                    typeof url === 'string' ? { url: url, result: true } : url
                  );
                }
              }

              // Items is already an array in the response
              if (shadeData.items && Array.isArray(shadeData.items)) {
                parsedItems = shadeData.items.map(item => ({
                  id: item.ROWID,
                  name: item.itemName || "",
                  item: item.itemName || "",
                  sku: item.sku || "",
                  type: item.type || "",
                  shadeNumber: item.shadeNumber || "",
                  fabric: item.fabric || "",
                  gsm: item.gsm || "",
                }));
              }
            } catch (error) {
              console.error("Error parsing data:", error);
              parsedMedia = [];
              parsedItems = [];
            }

            // Map the API response fields to your component's expected fields
            const mappedData = {
              shadeNumber: shadeData.shadeNo || shadeData.shadeNumber || "",
              category: shadeData.shadeCategory?.name || shadeData.shadeCategory || "",
              fabric: shadeData.fabric || "",
              maxWidth: shadeData.maxWidth || "",
              gsm: shadeData.gsm || "",
              uvBlockage: shadeData.uvBlockage || "",
              opennessFactor: shadeData.opennessFactor || "",
              greenGuard: shadeData.greenGuard || "",
              isPrintingRequired: shadeData.isPrintingRequired || false,
              description: shadeData.description || "",
              items: parsedItems,
              shadeMedia: parsedMedia,
              shadeName: shadeData.shadeName || "",
              rowId: shadeData.ROWID || "",
              createdTime: shadeData.CREATEDTIME || "",
              modifiedTime: shadeData.MODIFIEDTIME || "",
              creatorId: shadeData.CREATORID || "",
              modifierId: shadeData.MODIFIERID || "",
              // Map creator and modifier user objects if available
              createdBy: shadeData.createdBy || shadeData.creator || {
                firstName: shadeData.creatorFirstName || "",
                lastName: shadeData.creatorLastName || ""
              },
              modifiedBy: shadeData.modifiedBy || shadeData.modifier || {
                firstName: shadeData.modifierFirstName || "",
                lastName: shadeData.modifierLastName || ""
              }
            };

            console.log("Parsed shadeMedia:", parsedMedia);
            console.log("Parsed items:", parsedItems);
            console.log("Mapped data:", mappedData);

            setShadeDataDetail(mappedData);
            setItemImages(parsedMedia);

          } else {
            toast({
              title: "No shade data found",
              status: "warning",
              duration: 3000,
              isClosable: true,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching shade details:", error);
          toast({
            title: "Error fetching shade details",
            description: error.message || "Please try again",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [shadeId, toast]);

  const getImageUrl = (image) => {
    if (!image) return "";

    console.log("Processing image object:", image);

    // If image is an object
    if (image && typeof image === 'object') {
      // Check for url property
      if (image.url) {
        return image.url;
      }
      // Check for filePath property
      if (image.filePath) {
        return image.filePath;
      }
      // If it's a parsed object from the API
      if (image.result === true && image.url) {
        return image.url;
      }
    }

    // If image is already a URL string
    if (typeof image === 'string') {
      // Check if it's a URL
      if (image.startsWith('http')) {
        return image;
      }
      // Check if it contains a URL pattern
      if (image.includes('url=')) {
        const urlMatch = image.match(/url=([^,}]+)/);
        if (urlMatch && urlMatch[1]) {
          return urlMatch[1].trim();
        }
      }
    }

    return "";
  };

  // Get first 5 images for display
  const displayImages = itemImages.slice(0, 5);
  // Add empty slots if less than 5 images
  while (displayImages.length < 5) {
    displayImages.push({ url: "" });
  }

  useEffect(() => {
    // Simulate initial page load
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500); // Adjust time as needed

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box className="h-[93vh] flex flex-col mb-16">
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="#011638" />
        </div>
      )}

      {/* Header */}
      <Box className="d-flex align-items start justify-content-between sticky top-0 z-10 bg-white shadow-md ps-2 py-2">
        <span className='d-flex gap-2 justify-start items-center'>
          <ChevronLeft
            onClick={() => window.history.back()}
            className="hover:bg-gray-200 rounded-full cursor-pointer"
          />
          <h4 className="mb-0">Shade Detail</h4>
        </span>
      </Box>

      {/* Content */}
      <Box className="flex-1 overflow-y-auto p-6">
        <Flex direction={{ base: "column", md: "row" }}
          gap={6}
          mt={7}
          flexWrap="wrap" >
          {/* Shade Information */}
          <Box flex="1"
            p={{ base: 3, md: 4 }}
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="sm"
            bg="white"
            width={{ base: "100%", md: "50%" }}
            order={{ base: 2, md: 1 }}
          >
            <Heading size="md" mb={4}>
              Shade Information
            </Heading>

            <Flex
              gap={6}
              direction={{ base: "column", sm: "row" }}
              align={{ base: "center", sm: "flex-start" }}
            >
              <Box flex="1" width="100%">
                <Table size="sm">
                  <Tbody>
                    <Tr>
                      <Td fontWeight="bold">Shade Name</Td>
                      <Td>{shadeDataDetail.shadeName}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Shade Number</Td>
                      <Td>{shadeDataDetail.shadeNumber}</Td>
                    </Tr>

                    <Tr>
                      <Td fontWeight="bold">Category</Td>
                      <Td>{shadeDataDetail.category}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Max Width</Td>
                      <Td>{shadeDataDetail.maxWidth}</Td>
                    </Tr>

                    <Tr>
                      <Td fontWeight="bold">Fabric</Td>
                      <Td>{shadeDataDetail.fabric}</Td>
                    </Tr>

                    <Tr>
                      <Td fontWeight="bold">GSM</Td>
                      <Td>{shadeDataDetail.gsm}</Td>
                    </Tr>

                    <Tr>
                      <Td fontWeight="bold">UV Blockage</Td>
                      <Td>{shadeDataDetail.uvBlockage}</Td>
                    </Tr>

                    <Tr>
                      <Td fontWeight="bold">Green Guard</Td>
                      <Td>{shadeDataDetail.greenGuard}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Is Printing Required</Td>
                      <Td>{shadeDataDetail.isPrintingRequired ? "Yes" : "No"}</Td>
                    </Tr>

                    <Tr>
                      <Td fontWeight="bold">Created By</Td>
                      <Td>{getFullName(shadeDataDetail.createdBy)}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Modified By</Td>
                      <Td>{getFullName(shadeDataDetail.modifiedBy)}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Created Time</Td>
                      <Td>{formatDateTime(shadeDataDetail.createdTime)}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Modified Time</Td>
                      <Td>{formatDateTime(shadeDataDetail.modifiedTime)}</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </Box>
            </Flex>
          </Box>

          {/* Images Section */}
          <Box
            flex="1"
            p={{ base: 3, md: 4 }}
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="sm"
            bg="white"
            width={{ base: "100%", md: "50%" }}
            order={{ base: 1, md: 2 }}
          >
            <Heading as="h3" size="md" mb={4}>
              Item Images
            </Heading>

            <div className="grid gap-2 justify-items-center grid-cols-2 lg:grid-cols-3">
              {displayImages.map((image, index) => {
                const imageUrl = getImageUrl(image);
                console.log(`Image ${index}:`, image, "URL:", imageUrl);

                return (
                  <div key={index}>
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt={`img${index + 1}`}
                        style={{
                          width: "100%",
                          maxWidth: "180px",
                          height: "180px",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                        onError={(e) => {
                          console.error(`Failed to load image ${index}:`, imageUrl);
                          e.target.style.display = 'none';
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "180px",
                          height: "180px",
                          borderRadius: "8px",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#999",
                        }}
                      >
                        No Image
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Box>
        </Flex>

        <Box
          mt={4}
          mb={6}
          p={{ base: 4, md: 6 }}
          borderWidth="1px"
          borderRadius="lg"
          bg="white"
          boxShadow="sm"
        >
          <Heading size="md" mb={4}>
            Shade Wise Items
          </Heading>

          <Flex gap={4} mb={4}>
            <div className="overflow-x-auto">
              <table className="min-w-[200px] border-collapse border border-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border p-2 whitespace-nowrap">Items</th>
                  </tr>
                </thead>
                <tbody>
                  {shadeDataDetail.items && shadeDataDetail.items.length > 0 ? (
                    shadeDataDetail.items.map((item, index) => (
                      <tr key={item.id || index}>
                        <td className="p-2 border">{item.name || item.item || "No name"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="p-2 border">No items available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Flex>
        </Box>

        {/* Description */}
        <Box
          p={4}
          mb={20}
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="sm"
          bg="white"
        >
          <Heading size="md" mb={2}>
            Description
          </Heading>
          <Text whiteSpace="pre-wrap">
            {shadeDataDetail.description || "No description available"}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}

export default ShadeDetail;